export const formatNumberES = (numberData) => {
  const formattedQuantity = new Intl.NumberFormat('es-CL', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(numberData);

  return formattedQuantity;
}